import { combineReducers } from "redux";
import AuthReducer from "./search/reducer";

export const rootReducer = combineReducers({
  authState: AuthReducer
});
